export async function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('nsDB', 1);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains('nsStore')) {
        db.createObjectStore('nsStore', { keyPath: 'id' });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = (event) => reject((event.target as IDBOpenDBRequest).error);
  });
}

export interface NewSparkData {
  faceId?: number;
  dbId: number;
}

export async function setData(data: NewSparkData): Promise<boolean> {
  try {
    const db = await openDB();
    const transaction = db.transaction('nsStore', 'readwrite');
    const store = transaction.objectStore('nsStore');
    store.put({ id: 1, ...data }); // Always using id = 1

    return new Promise((resolve, reject) => {
      transaction.oncomplete = () => resolve(true);
      transaction.onerror = (event) => reject((event.target as IDBTransaction).error);
    });
  } catch (error) {
    console.error('Error saving data:', error);
    return false;
  }
}
export async function getData(): Promise<NewSparkData | null> {
  try {
    const db = await openDB();
    const transaction = db.transaction('nsStore', 'readonly');
    const store = transaction.objectStore('nsStore');
    const request = store.get(1);

    return new Promise((resolve, reject) => {
      request.onsuccess = () => {
        const result = request.result as NewSparkData | null;
        resolve(result && result.dbId ? result : null); // Ensure dbId exists
      };
      request.onerror = () => reject(new Error('Error retrieving data'));
    });
  } catch (error) {
    console.error('Error retrieving data:', error);
    return null;
  }
}

export async function clearData(): Promise<boolean> {
  try {
    const db = await openDB();
    const transaction = db.transaction('nsStore', 'readwrite');
    const store = transaction.objectStore('nsStore');
    store.delete(1); // Remove the only record

    return new Promise((resolve, reject) => {
      transaction.oncomplete = () => resolve(true);
      transaction.onerror = (event) => reject((event.target as IDBTransaction).error);
    });
  } catch (error) {
    console.error('Error clearing data:', error);
    return false;
  }
}

